/**
 *  Format JS date into WF format
 *
 * @param {string|Integer} timestamp date that is to be formatted
 * @param {Boolean} isSmallDevice current device is mobile or desktop, default is desktop
 * @return {string} the formatted date string, MM/DD/YY for Desktop and MM/YY for mobile
 */
export const getFormattedDate = (timestamp, isSmallDevice = false) => {
	const d = new Date(timestamp);
	if (isSmallDevice)
		return (
			d.getMonth() +
			1 +
			"/" +
			d
				.getFullYear()
				.toString()
				.substr(2)
		);
	return (
		d.getMonth() +
		1 +
		"/" +
		d.getDate() +
		"/" +
		d
			.getFullYear()
			.toString()
			.substr(2)
	);
};
